/**
=========================================================
* Material Kit 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Kit 2 PRO React base styles
import colors from "../../base/colors";
import borders from "../../base/borders";
import boxShadows from "../../base/boxShadows";

// Material Kit 2 PRO React helper functions
import pxToRem from "../../functions/pxToRem";
import linearGradient from "../../functions/linearGradient";
import { color } from "@mui/system";

const { transparent, gradients } = colors;
const { borderRadius } = borders;
const { colored } = boxShadows;

export default {
  styleOverrides: {
    root: {
    //  background: linearGradient(gradients.info.main, gradients.info.state),
      // background: 'rgba(52, 52, 52, 0.1)',
      padding: `${pxToRem(24)} 0 ${pxToRem(16)}`,
      // borderRadius: borderRadius.lg,
      // boxShadow: colored.info,

      "&.MuiPaper-root": {
        backgroundColor: transparent.main,
       
      },

      "&.audittrail1": {
        background: colors.black.main,
        boxShadow: colored.boxShadow,
      },
    },
  },
};
